import { isEmpty } from '@sgme/fp';
import { CenterSpinner } from 'components/shared/CenterSpinner/CenterSpinner';
import { ProductList } from 'components/shared/ProductAndClientSelector/ProductList';
import { ProductMostRecentUnavailable } from 'components/shared/ProductAndClientSelector/ProductMostRecentUnavailable';
import type { ProductVariation } from 'models/productsReferential';
import { useSelector } from 'react-redux';
import type { AppState } from 'state/state.model';
import type { WorkspaceWithProductSelector } from 'state/workspaces/workspaces/workspaces.model';
import { getMostRecentProductsOpened } from 'state/workspaces/workspaces/workspaces.selector';

import { ProductMostRecentEmpty } from './ProductMostRecentEmptyList';

export interface ProductMostRecentListProps {
  workspace: WorkspaceWithProductSelector;
  selectedProductVariation: Partial<ProductVariation>;
  onProductVariationSelected(product: Partial<ProductVariation>, quickStart: boolean): void;
}
export function ProductMostRecentList({
  workspace,
  selectedProductVariation,
  onProductVariationSelected,
}: ProductMostRecentListProps) {
  const response = useSelector((state: AppState) => getMostRecentProductsOpened(state, workspace));

  switch (response.status) {
    case 'loading':
      return <CenterSpinner />;
    case 'timeout':
    case 'error':
      return <ProductMostRecentUnavailable />;
    case 'success':
      return isEmpty(response.payload) ? (
        <ProductMostRecentEmpty />
      ) : (
        <ProductList
          className="h-100 border border-top-0 rounded-1 rounded-top"
          productVariations={response.payload}
          selectedProductVariation={selectedProductVariation}
          onProductVariationSelected={onProductVariationSelected}
          tabType="mostRecent"
          workspace={workspace}
        />
      );
  }
}
